import React, {Component} from 'react'

import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import _ from 'lodash';
// import './index.css'
import './../../styles/css/screens/UserEntries/user-entries.css'
// import './index_320.css'

import {DataActionTypes as DataAT, Constants, strings, colors, CCEntryItem, CCActions, CCActivityIndicator} from './../../cc-imports'
import CCSectionList from "../../components/CCSectionList/CCSectionList";
import {CCUIUtils} from "../../cc-imports";


class UserEntries extends Component {

    static propTypes = {}

    static defaultProps = {}

    constructor(props) {
        super(props)

        /*this.ref = Firebase.firestore().collection('entries');
        this.unsubscribe = {};
        this.storeData=[];*/


        this.state = {
            data: [],
            reqPending:false
        };

        this._fetchEntries = this._fetchEntries.bind(this);
        this._autoRefresh = this._autoRefresh.bind(this);
        this._manualRefresh = this._manualRefresh.bind(this);
        this._paginate = this._paginate.bind(this);
        this._updateGrouping = this._updateGrouping.bind(this);
        //this._onEntriesUpdate = this._onEntriesUpdate.bind(this);
    }

    _fetchEntries(type) {
        const {userId, actions, pages, reqStatus} = this.props;
        if(this.state.reqPending==true) return;

            this.setState({reqPending : true},()=>{
                var page = pages[userId] == undefined ? 0 : pages[userId];
                var skip = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? 0 : page;
                var limit = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? page * 20 : 20;
                if (userId) {
                    actions.getEntriesByUserId(userId, skip, limit, type).then(() => {
                        this.setState({reqPending : false});
                    }).catch(()=>{
                        this.setState({reqPending : false});
                    })
                }
            })

    }

    _autoRefresh() {
        this._fetchEntries(DataAT.AUTO_REFRESH);
    }

    _manualRefresh() {
        this._fetchEntries(DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        const {reqStatus} = this.props;
        if (reqStatus != Constants.reqStatus.FAI && reqStatus != Constants.reqStatus.COM) {
            this._fetchEntries(DataAT.PAGINATE);
        }
    }


    _closeModal() {
        this.props.actions.closeModal("Entries");
    }

    _updateGrouping(props) {
        const {userId, byCreatorId, byId} = props;

        var entryIds = byCreatorId[userId];

        var entriesForUser = [];

        _.forEach(entryIds, (entryId) => {
            entriesForUser.push(byId[entryId]);
        });

        entriesForUser = _.orderBy(entriesForUser, [function (entry) {
            //console.log(entry);
            return new Date(entry.createdDate);
        }], ['desc']);

        var groupedEntries = _.groupBy(entriesForUser, (entry) => {
            //console.log('++--++__++__++', entry)
            switch (entry.status) {
                case Constants.entryStatus.LIVE:
                    return 'Live';
                case Constants.entryStatus.NOT_STARTED:
                    return 'Upcoming';
                default:
                    return 'Completed';
            }
        });


        var data = []
        _.forIn(groupedEntries, function (value, key) {
            var priority = 0;
            //console.log("key value   ", key, value);
            switch (key) {
                case 'Live':
                    priority = 10;
                    break;
                case 'Upcoming':
                    priority = 5;
                    break;
                default:
                    priority = 0;

                    //console.log("----- -- -", priority)
            }
            data.push({
                data: value,
                title: key,
                priority: priority
            })
        });

        //console.log("grouped data", data);

        data = _.orderBy(data, ['priority'], ['desc'])

        return data;
    }


    componentDidMount() {
        if (this.props.userId) {
            this._fetchEntries(DataAT.GET);
        }
    }

    render() {
        const user = this.props.user;
        const {reqStatus, type} = this.props;
        const data =this._updateGrouping(this.props);
        return (
            <div style={{flex:1}}>
                    <div style={{alignItems: 'center', justifyContent: 'center', marginBottom: 10, marginTop: 10}}>
                        <h2 className={'user-entry-title'}>{strings('entries')}</h2>
                    </div>
                    <div className={'flex-container won-container'}>
                        <div className={'flex-container'} style={{flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{
                                flex: 1,
                                borderRightColor: colors.theme2.border_color1,
                                flexDirection: 'column',
                                borderRightWidth: 0.5,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}>
                                <h1 className={'user-entry-entries-won'}>{user.entriesWon}</h1>
                                <h1 className={'user-entry-won-title'}>{strings('won_title')}</h1>
                            </div>
                        </div>
                        <div className={'flex-container'} style={{flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{
                                flex: 1,
                                borderRightColor: colors.theme2.border_color1,
                                flexDirection: 'column',
                                borderRightWidth: 0.5,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}>
                                <h1 className={'user-entry-entries-won'}>{user.entriesLost}</h1>
                                <h1 className={'user-entry-won-title'}>{strings('lost_title')}</h1>
                            </div>
                        </div>
                        <div className={'flex-container'} style={{flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{
                                flex: 1,
                                borderRightColor: colors.theme2.border_color1,
                                flexDirection: 'column',
                                borderRightWidth: 0.5,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}>
                                <h1 className={'user-entry-entries-won'}>{user.entriesRefunded}</h1>
                                <h1 className={'user-entry-won-title'}>{strings('refunded_title')}</h1>
                            </div>
                        </div>
                        <div className={'flex-container'} style={{flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                            <div style={{
                                flex: 1,
                                borderRightColor: colors.theme2.border_color1,
                                flexDirection: 'column',
                                borderRightWidth: 0.5,
                                alignItems: 'center',
                                justifyContent: 'center',
                                textAlign: 'center'
                            }}>
                                <h1 className={'user-entry-entries-won'}>{user.noOfEntries}</h1>
                                <h1 className={'user-entry-won-title'}>{strings('total')}</h1>
                            </div>
                        </div>
                    </div>
                    <div style={{flex: 1}}>
                        {
                            (data && data.length>0)?
                                <CCSectionList
                                    scrollClassName={'user-entries-scroll'}
                                    onEndReached={this._paginate}
                                    onEndReachedThreshold={1}
                                    renderItem={(entry) => <CCEntryItem entry={entry} key={entry.id}></CCEntryItem>}
                                    renderSectionHeader={(section) => <div className={'flex-container'} style={{justifyContent: 'center', alignItems: 'center', margin: 5}}><h1 className={' user-entries-section-header'}>{section.title}</h1></div>}
                                    sections={data}
                                    ListEmptyComponent={CCUIUtils.getEmptyListItem(reqStatus)}
                                    // ListFooterComponent={CCUIUtils.getListFooter(reqStatus, type, data)}
                                    endReached={reqStatus==Constants.reqStatus.FAI||reqStatus==Constants.reqStatus.COM}
                                />
                                :
                                CCUIUtils.getEmptyListItem(reqStatus)
                        }

                    </div>
            </div>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user.user,
        byId: state.entries.byId,
        byLeague: state.entries.byLeague,
        byCreatorId: state.entries.byCreatorId,
        liveScores: state.entries.liveScores,
        pages: state.entries.pages,
        userId: state.user.user.id,
        random: state.entries.random,
        type: state.entries.type,
        reqStatus: state.entries.reqStatus
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(UserEntries);


// WEBPACK FOOTER //
// ./src/app/screens/UserEntries/UserEntries.js